module.exports = __webpack_public_path__ + "img/empty_images.3366b1ed.svg";